export default __webpack_public_path__ + "static/media/style-belgardHolland.af6dc64f.jpg";